import React, { useState } from 'react';

import GraphemeSplitter from 'grapheme-splitter';

import { ReactComponent as PillShapeMaskMobile } from '@pkg/assets/icons/v2/pill-shape-mask-mobile.svg';
import { ReactComponent as PillShapeMask } from '@pkg/assets/icons/v2/pill-shape-mask.svg';
import { YatSprite } from '@pkg/components/YatSprite/YatSprite';

import { type EmojiId } from '@app/client/common/structs/emoji/emoji';

import { Pill } from './components';
import { OVERLAP } from './tokens';

import { Picker, PickerOuter, Wrapper } from './styles';

const graphemeSplitter = new GraphemeSplitter();

export interface YatSelectorProps {
    currentEmoji: EmojiId;
    twitterHandle?: string;
    isSmall?: boolean;
    showDropdown?: boolean;
    showTwitterHandle?: boolean;
    animateTwitterHandle?: boolean;
    animateShine?: boolean;
    disableShine?: boolean;
    handleClick?(): void;
}

// TODO: Why do any of these components require a `className`?
export function YatSelector({
    currentEmoji,
    twitterHandle = '@yourtwitter',
    isSmall = false,
    showDropdown = false,
    showTwitterHandle = false,
    animateTwitterHandle = false,
    animateShine = false,
    disableShine = false,
    handleClick,
}: YatSelectorProps) {
    const [twitterHandleLength, setTwitterHandleLength] = useState(0);

    function updateHandleLength(value: number) {
        setTwitterHandleLength(value);
    }

    const showHoverEffect = Boolean(handleClick);

    // TODO: Why would there be no `currentEmoji`?
    // It is a required prop. Are we worried about a empty string?
    // If so, what is the problem with letting the component render?
    if (!currentEmoji) return null;

    const emojiList = graphemeSplitter.splitGraphemes(currentEmoji);

    return (
        <Wrapper
            className="yat-picker-two-wrapper"
            hoverEffect={showHoverEffect}
            isAnimated={(twitterHandleLength > 0 && showTwitterHandle && animateTwitterHandle) || animateShine}
            disableShine={disableShine}
            isSmall={isSmall}
            hasLongTwitter={twitterHandleLength > 300}
            onClick={handleClick}
        >
            <PillShapeMask />
            <PillShapeMaskMobile />

            {showDropdown && <Pill isSmall={isSmall} hasOnlyOne={emojiList.length === 1} showChevron />}

            {showTwitterHandle && (
                <Pill
                    hasOnlyOne={emojiList.length === 1}
                    showTwitterHandle
                    updateHandleLength={updateHandleLength}
                    twitterHandleLength={twitterHandleLength + OVERLAP}
                    twitterHandle={twitterHandle}
                    animateTwitterHandle={animateTwitterHandle}
                    isSmall={isSmall}
                />
            )}

            <PickerOuter className="picker" isSmall={isSmall}>
                <Picker isSmall={isSmall} hasOnlyOne={emojiList.length === 1} className="v2-global-reset">
                    <div>
                        {emojiList.map((emoji, index) => {
                            return <YatSprite key={`YatSelector-YatSprite-${index}`} emojiID={emoji} />;
                        })}
                    </div>
                </Picker>
            </PickerOuter>
        </Wrapper>
    );
}
